import { Record } from '@gonfalon/immutable-shim/immutableShim';

export class Defaults extends Record<{ onVariation?: number; offVariation?: number }>({
  onVariation: 0,
  offVariation: 1,
}) {}
